var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0802 4.39295C16.8728 3.62365 18.1579 3.62365 18.9505 4.39295L20.2014 5.60705C20.9941 6.37636 20.994 7.62365 20.2014 8.39295L8.83712 19.423C8.45649 19.7925 7.94024 20 7.40195 20L4.12144 20L4.12144 16.816C4.12144 16.2935 4.33528 15.7925 4.7159 15.423L16.0802 4.39295Z",
    stroke: "#545565",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4246 6L18.5458 10",
    stroke: "#545565",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8ae86e6d1c47fac873dd0c037c8d44f8.svg";
export { ForwardRef as ReactComponent };